import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './calendar-styles.css';
import App from './App';
import DisableDevtool from 'disable-devtool';

// Only block devtools in production. In development the bypass key is active
// automatically — add ?ddtk=commission2026 to any URL to bypass in production too.
if (process.env.NODE_ENV === 'production') {
  DisableDevtool({
    md5: 'e80faf5159c0df2af5475a55611f6ebd', // md5 of bypass key "commission2026"
    tkName: 'ddtk',
    disableMenu: false,
    disableSelect: false,
    disableCopy: false,
    interval: 500,
    url: window.location.origin, // redirect to same origin if devtools opened
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
